import { Product, ProductType } from '@/api';
import { FormSelectOption } from './form-select-option';

export const getProductTrialPlanOptions = (product: Product): FormSelectOption[] => {
	switch (product.type) {
		case ProductType.Milk: {
			return [
				{ value: 'trim', text: 'Trim' },
				{ value: 'blueTop', text: 'Blue Top' },
				{ value: 'fullCream', text: 'Full Cream' },
			];
		}
		case ProductType.Fuel: {
			return [
				{ value: 'lite', text: 'Lite' },
				{ value: 'regular', text: 'Regular' },
				{ value: 'super', text: 'Super' },
				{ value: 'premium', text: 'Premium' },
			];
		}
		case ProductType.Water: {
			return [{ value: 'premium', text: 'Premium' }];
		}
		case ProductType.Feed: {
			return [{ value: 'fullLoad', text: 'Full Load' }];
		}
		default: {
			return [];
		}
	}
};
